import {
  SET_ARRANGEMANG,
  FETCH_ARRANGEMANG_PROPERTIES,
  FETCH_DELTAGARE,
  CLEAR_ARRANGEMANG,
  ADD_REQUIRED_FIELDS,
  ADD_ERRORS,
  ADD_STEP,
  ADD_STEPS,
  RETRIEVED_ERROR,
  NEXT_STEP,
  PREVIOUS_STEP,
  CHANGE_STEP,
  SET_OREGELBUNDNA_SAMMANKOMSTER,
  SET_SCHEMA_KROCKAR,
} from "../constants/arrangemang";

const initialState = {
  arrangemang: null,
  wizardErrors: [],
  deltagare: {},
  currentStep: 0,
  arrangemangOverview: {},
  steps: [],
  requiredFields: {},
  obligatoriskaFalt: {
    notering: null,
    sal: null,
    material: null,
    studieplan: null,
    startdatum: null,
    starttid: null,
    sluttid: null,
    planeratAntalSammankomster: null,
    planeratAntalTimmar: null,
    kulturform: null,
    huvudledare: null,
  },
  permissions: [],
  stepsCreate: [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  oregelbundnaSammankomster: { schemas: [], arrangemangID: "" },
  schemaKrockar: { krockar: [], arrangemangID: "" },
};

export const arrangemang = (state = initialState, action) => {
  switch (action.type) {
    case SET_ARRANGEMANG:
      return {
        ...state,
        arrangemang: action.payload.arrangemang,
        messages: action.payload.requiredFields,
      };
    case RETRIEVED_ERROR:
      return { ...state, errors: action.payload };
    case FETCH_DELTAGARE: {
      return { ...state, deltagare: action.payload };
    }
    case ADD_ERRORS: {
      return {
        ...state,
        wizardErrors: [...action.payload],
      };
    }
    case NEXT_STEP:
      return { ...state, currentStep: state.currentStep + 1 };
    case PREVIOUS_STEP:
      return { ...state, currentStep: state.currentStep - 1 };
    case CHANGE_STEP: {
      let wizardSteps = state.steps;
      wizardSteps.forEach((step, index) => {
        step.isActive = action.payload === index;
      });

      return {
        ...state,
        currentStep: action.payload,
        steps: wizardSteps,
      };
    }
    case FETCH_ARRANGEMANG_PROPERTIES:
      return {
        ...state,
        permissions: action.payload.permissions,
        isReadyToStart: action.payload.isReadyToStart,
        isSamvGruppRequired: action.payload.isSamvGruppRequired,
        komplNotLength: action.payload.komplNotLength,
        hasRedigera: action.payload.hasRedigera,
        isExternUser: action.payload.isExternUser,
        isKultur: action.payload.isKultur,
        showEkonomi: action.payload.showEkonomi,
        showWebb: action.payload.showWebb,
        editableFields: action.payload.editableFields,
      };
    case ADD_REQUIRED_FIELDS:
      return {
        ...state,
        requiredFields: action.payload,
      };
    case ADD_STEPS:
      return {
        ...state,
        steps: action.payload,
      };
    case ADD_STEP:
      return {
        ...state,
        steps: [...state.steps, action.payload],
      };
    case SET_OREGELBUNDNA_SAMMANKOMSTER:
      return {
        ...state,
        oregelbundnaSammankomster: {
          schemas: action.payload.schemas,
          arrangemangID: action.payload.arrangemangID,
        },
      };
    case SET_SCHEMA_KROCKAR:
      return {
        ...state,
        schemaKrockar: {
          krockar: action.payload.krockar,
          arrangemangID: action.payload.arrangemangID,
        },
      };
    case CLEAR_ARRANGEMANG:
      return initialState;
    default:
      return state;
  }
};
